var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useState } from 'react';
export function useContent(initialState) {
    var _a = useState(initialState), contents = _a[0], setContents = _a[1];
    var content = contents[contents.length - 1];
    var setContent = useCallback(function (content) { return setContents(function (state) { return __spreadArray(__spreadArray([], state, true), [content], false); }); }, [setContents]);
    var removeContent = useCallback(function (content) { return setContents(function (state) { return state.filter(function (c) { return c !== content; }); }); }, [setContents]);
    return [content, setContent, removeContent];
}
